<script>
export default {
    name: "ApproveCancelForm",

    data() {

        return {
            memo: ``,
        };
    },

    props: {
        payment: {
            type: Object,
            required: true,
        },
        showModal: {
            type: Boolean,
            required: true,
        }
    },

    methods: {

        saveApprovalOrCancel(approve) {
            if(!window.confirm(`Confirm action`)) return;

            let url = approve ? `SupplierPayments/ApproveSupplierPayments` : `SupplierPayments/CancelSupplierPayments`;
            const payment = {
                remID: this.payment.remittanceNo,
                txnDate: this.$moment().format(`YYYY-MM-DD`),
                username: this.$root.username,
                postMemo: this.memo,
            };
            this.$root.loading = true;
            this.$http.post(url, payment).then(({ data }) => {
                this.memo = ``;
                this.$emit(`refresh`);
                this.$root.loading = false;
                this.$emit(`closeModal`);
                window.Swal.fire({type: `success`, text: data});
            }).catch(() => { this.$root.loading = false; });
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/2 w-11/12">
      <template v-slot:title>
        <h5 class="font-medium text-sm">Approve/Cancel Payment</h5>
      </template>
      <template v-slot:modal-body>
        <div class="w-full flex flex-wrap items-center bg-gray-300 p-2">
            <div class="md:w-1/4 w-full p-1">
                <h5>Supplier: {{ payment.name }}</h5>
            </div>
            <div class="md:w-1/4 w-full p-1">
                <h5>Ref: {{ payment.remittanceNo }}</h5>
            </div>
            <div class="md:w-1/4 w-full p-1">
                <h5>Mode: {{ payment.mode }}</h5>
            </div>
            <div class="md:w-1/4 w-full p-1">
                <h5>Amount: {{ $formatCurrency(payment.paidAmount) }}</h5>
            </div>
        </div>
        <div class="w-full">
            <label for="grid-memo" class="label-control">Memo</label>
            <textarea 
                v-model.trim="memo"
                id="grid-memo" rows="3" 
                class="input-control input-sm text-xs"></textarea>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button 
            class="btn-danger btn-sm text-xs rounded mr-6" 
            @click.prevent="$emit(`closeModal`)"><i class="fa fa-times"></i> Close</button>
        <button 
            @click.prevent="saveApprovalOrCancel(true)"
            class="btn-primary btn-sm text-xs rounded mr-6"><i class="fa fa-check"></i> Approve</button>
        <button 
            @click.prevent="saveApprovalOrCancel(false)"
            class="btn-warning btn-sm text-xs rounded"><i class="fa fa-ban"></i> Cancel Payment</button>
      </template>
    </tail-modal>
</template>
